const React = require('react');
const T = require('prop-types');
const { default: Classes } = require('./styles.scss');
const CenteredLayout = require('components/CenteredLayout');
const { analyticsTemplates } = require('utils/analytics');
const ChangePasswordCard = require('components/ChangePasswordCard');

const internals = {};

module.exports = function ChoosePassword(props) {

    const {
        signupContext: {
            verificationToken
        },
        usePasswordRules,
        onSubmit
    } = props;
    // eslint-disable-next-line hapi/hapi-scope-start, hapi/no-arrowception
    const submit = ({ newPassword, agreeToTerms }) => {

        analyticsTemplates.buttons('save password', 'create account: save password');

        return onSubmit({
            password: newPassword,
            agreeToTerms: agreeToTerms === true,
            verificationToken
        });
    };

    return <CenteredLayout
        header='Create Account'
        mainClass={Classes.main}>

        <ChangePasswordCard
            usePasswordRules={usePasswordRules}
            mainTitle='Email Verified'
            subtitle='Please set your new password'
            showAgreeToTerms={true}
            onSubmit={submit}
            isSignup
        />
    </CenteredLayout>;
};

module.exports.propTypes = {
    onSubmit: T.func.isRequired,
    signupContext: T.shape({
        verificationToken: T.string
    }),
    usePasswordRules: T.bool
};
